module.exports = __webpack_public_path__ + "media/images/doctor-day/doctorday-template-ge-a2a9f747c852c98040cc9863061a5144.png";